import {AfterViewInit, Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Photo} from '../../../../shared/models/cameralla-photo.model';
import {Location} from '@angular/common';
import {PhotoService} from '../../services/photo.service';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import * as $ from 'jquery';
import {RatingService} from '../../services/rating.service';
import {ReviewPopupComponent} from "../review-popup/review-popup.component";
import {FormGroupDirective, Validators} from "@angular/forms";
import {UserComments} from "../../services/user-comments.service";
import { UserStatusConstant } from "../../../../shared/constants/user-status-constant";

@Component({
    selector: 'app-review-section',
    templateUrl: './review-section.component.html',
})
export class ReviewSectionComponent implements OnInit, AfterViewInit {
    @Input('photoDetails') photoDetails: Photo;
    @Input('photosByUser') photosByUser: Photo[];
    @Input('reviewObject') reviewObject;
    @Input('criterion') criterion;
    @Input('currentFeedback') currentFeedback;
    @ViewChild('reviewForm') reviewForm: FormGroupDirective;
    @Input('localUserId') localUserId: any;
    @Output() emitPreview = new EventEmitter<any[]>();

    reviewValid = true;
    ratingValid = true;
    maxLength = 1000;
    editableFeedback: any;
    // isEdit: boolean;
    reviewTab = ReviewPopupComponent.criterionConst;
    selectedCriteria = null;
    onSaving:boolean = false;
    flag:boolean = false;

    constructor(private location: Location,
                private photoService: PhotoService,
                private router: Router,
                private toastr: ToastrService,
                private userCommentsService: UserComments,
                private ratingService: RatingService) {
    }

    ngOnInit() {
        this.selectedCriteria = this.reviewTab[0];
        // this.isEdit = false;
        this.currentFeedback.then(
            response => {
                this.getCurrentFeedback(response['Data'].id);
            },
            error => {
                console.log('getPhotoDetails error ' + error);
            });
    }

    ngAfterViewInit() {
        setTimeout(() => {
            $('html, body').animate(
                {
                    scrollTop: $('#review_section').offset().top - $('main').offset().top + $('main').scrollTop() - 70
                }, 'slow');
        }, 1000);

        setTimeout(() => {

            if (this.reviewForm && this.reviewForm.form) {
                this.reviewForm.form.get('general_text').setValidators([Validators.maxLength(this.maxLength)]);
                // this.reviewForm.form.get('vision_text').setValidators([Validators.maxLength(this.maxLength)]);
                // this.reviewForm.form.get('composition_text').setValidators([Validators.maxLength(this.maxLength)]);
                // this.reviewForm.form.get('cameraSettings_text').setValidators([Validators.maxLength(this.maxLength)]);
                // this.reviewForm.form.get('editing_text').setValidators([Validators.maxLength(this.maxLength)]);
                // this.reviewForm.form.get('presentation_text').setValidators([Validators.maxLength(this.maxLength)]);
            }
            
            if (this.photoDetails.customerId == this.localUserId || this.photoDetails.customer.status === UserStatusConstant.DELETED) {
                this.goBack();
            }
        }, 100)
    }

    getCurrentFeedback(photoId) {
        this.ratingService.getRatingByPhoto(photoId).toPromise().then(
            response => {
                if (response['IsSuccess']) {
                    const comments = response['Data'];

                    if (comments.length) {
                        for (const comment of comments) {
                            if (comment.customerId === this.localUserId) {
                                // this.isEdit = true;
                                this.editableFeedback = comment;
                            }
                        }

                        // if (this.isEdit) {
                        //     this.criterion.forEach((each:any) => {
                        //         this.reviewObject[`${each['name']}_text`] = this.editableFeedback[`${each['name']}_text`];
                        //         console.log(this.reviewObject[`${each['name']}_text`]);
                        //         each.value = this.editableFeedback[`${each['name']}`];
                        //     });
                        // }
                    }

                    // Flag on when user rating then comment.
                    if (!this.reviewObject.general_text) {
                        this.flag = true;
                    }
                }
            },
            err => console.log('Comment API Error ' + err)
        );
    }

    setCommentView(criteria) {
        this.selectedCriteria = criteria;
        //this.commentCount();
    }

    myRating() {
        return this.criterion[0].value
    }

    totalStars() {

    }

    preview(reviewForm) {
        let tooLong = false;
        this.ratingValid = this.isRating(this.criterion);

        for (const key in reviewForm.value) {
            if (reviewForm.value.hasOwnProperty(key)) {
                if (reviewForm.value[key] && reviewForm.value[key].length > this.maxLength) {
                    tooLong = true;
                }
            }
        }

        if (!this.ratingValid) {
            this.reviewValid = false;

            return this.failValidation('#rating_warning');
        }

        if (reviewForm.invalid || tooLong) {
            this.reviewValid = false;

            return this.failValidation('.text-danger:first');
        }

        this.reviewValid = true;
    }

    goBack() {
        this.router.navigate([`/photo/${this.photoDetails.id}`]);
    }

    isRating(criterion: any[]) {
        for (const criteria of criterion) {
            if (criteria.value === 0.0) {
                return false;
            }
        }

        return true;
    }

    onScroll() {
        if (!$('<ngb-tooltip-window>').hidden) {
            $('button[aria-describedby]').click();
        }
    }

    openLightbox(): void {
        this.photoService.openLightbox([{
            src: this.photoDetails.original,
            caption: this.photoDetails.title + ' - ' + this.photoDetails.customer.fullName,
            thumb: this.photoDetails.thumbnail
        }]);
    }

    failValidation(element: string) {
        setTimeout(() => {
            $('html, body').animate(
                {
                    scrollTop: $(element).offset().top - $('main').offset().top + $('main').scrollTop() - 50
                }, 'slow');
        }, 0);
    }

    submit() {
        const ratingObj = Object.assign({}, this.reviewObject);

        this.criterion.forEach(each => {
            ratingObj[`${each['name']}`] = each['value'];
        });

        this.onSaving = true;
        
        this.ratingService.ratePhoto(ratingObj).toPromise().then(
            response => {
                if (response['IsSuccess']) {

                    this.sendNotification(response['Data']['owner_rating']);

                    this.goBack();
                    this.toastr.success('Photo has been reviewed successfully', 'DONE');
                } else {
                    this.toastr.error('Something went wrong. Please try again later', 'ERROR');
                }
            },
            error => {
                console.log('ratePhoto error ' + error);
                this.onSaving = false;
                this.toastr.error(error.message, 'FAILED');
            }
        );
        // }
    }

    sendNotification(data) {
        const ratingData = {
            content: data.general_text,
            photoId: data.photoId,
            modelId: data.id
        };
    
        this.userCommentsService.sendMessage([], this.photoDetails['customer'], this.localUserId, ratingData, this.photoDetails['group']);
    }
}
